// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__nK2q_","list":"BalanceDue_list__EDOEF","listRow":"BalanceDue_listRow__1D12m","total":"BalanceDue_total__19DU1"};